module.exports = __webpack_public_path__ + "static/ofcar11-c4d1451583a2adf4da4739d9e9cf2cb6.jpg";